/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MailTemplateResource } from '../models/MailTemplateResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MailTemplateService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les modeles d'e-mail
     * Les modeles par defaut (`name`, `place_holders`, `default_subject`, `default_content`, destinataires par defaut), que chaque entreprise peut surcharger.
     * @returns MailTemplateResource Array of `MailTemplateResource`
     * @throws ApiError
     */
    public adminMailtemplatesIndex(): CancelablePromise<Array<MailTemplateResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/mailtemplates',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Creer un modele d'e-mail
     * `name`, `place_holders` (variables utilisables dans le sujet et le contenu), `default_subject`, `default_content`, `default_to`, `default_carbon_copy`, `default_carbon_copy_invisible`.
     * @param requestBody
     * @returns MailTemplateResource `MailTemplateResource`
     * @throws ApiError
     */
    public adminMailtemplatesStore(
        requestBody: {
            name: string;
            place_holders: string;
            default_content: string;
            default_subject: string;
            default_to: string;
            default_carbon_copy?: string;
            default_carbon_copy_invisible?: string;
        },
    ): CancelablePromise<MailTemplateResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/mailtemplates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un modele d'e-mail
     * @param id
     * @returns MailTemplateResource `MailTemplateResource`
     * @throws ApiError
     */
    public adminMailtemplatesShow(
        id: string,
    ): CancelablePromise<MailTemplateResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/mailtemplates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un modele d'e-mail
     * Mise a jour partielle. Les surcharges par entreprise ne sont pas touchees.
     * @param id
     * @param requestBody
     * @returns MailTemplateResource `MailTemplateResource`
     * @throws ApiError
     */
    public adminMailtemplatesUpdate(
        id: string,
        requestBody: {
            name: string;
            place_holders: string;
            default_content: string;
            default_subject: string;
            default_to: string;
            default_carbon_copy?: string;
            default_carbon_copy_invisible?: string;
        },
    ): CancelablePromise<MailTemplateResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/mailtemplates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un modele d'e-mail
     * Avec ses surcharges par entreprise.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminMailtemplatesDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/mailtemplates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
